import React from 'react';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import DyanamicDropdown from 'components/Elements/DynamicDropdown';
import { useFilters } from '../FilterContext';
import { useAssets } from './hooks/useAssets';
import { useFilterInitialization } from './hooks/useFilterInitialization';
import { SHOW_ALL_OPTION } from '../constants';

export const AssetFilter = () => {
  const { t } = useTranslation();
  const { filterValues, updateFilter, config, isShowAll } = useFilters();
  const { customCaptions } = JSON.parse(sessionStorage.getItem("me")) || JSON.parse(localStorage.getItem("me"));

  const modelId = filterValues.model?.value?.id;
  const showAllEnabled = isShowAll('asset');
  const assets = useAssets(modelId, showAllEnabled);

  // Clean, declarative initialization with model dependency
  useFilterInitialization('asset', assets, {
    dependencies: [modelId],
    resetOnDependencyChange: true,
    waitForData: true,
    getDefaultValue: () => SHOW_ALL_OPTION,
    getParams: (item) => ({ siteAssetRegisterId: item.id || '' })
  });

  // Don't show if model type doesn't match
  if (config.filters.asset?.show && !config.filters.asset.show(filterValues.model?.value)) {
    return null;
  }

  if (!filterValues.asset) {
    return null;
  }

  return (
    <Grid item lg={3} md={6} xs={12}>
      <DyanamicDropdown
        dataSource={assets}
        columns={[{ name: 'name', id: 1 }]}
        showHeader={false}
        width="100%"
        placeholder={t("placeholder.selectEntity", { entity: customCaptions?.asset || 'Asset' })}
        onChange={item => updateFilter('asset', item, { siteAssetRegisterId: item.id })}
        selectdValueToshow="name"
        selectedValue={filterValues.asset?.value}
        label={t("label.filterByEntity", { entity: customCaptions?.asset || 'Asset' })}
        icon={<FilterListIcon style={{ color: 'rgb(48,122,215)' }} />}
        required={false}
        showBorderColor
        showClear={true}
        onClear={() => updateFilter('asset', SHOW_ALL_OPTION, { siteAssetRegisterId: '' })}
      />
    </Grid>
  );
}; 
